import React, { useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

// Password input with a hold-to-reveal eye icon.
// Press & hold the eye to show the password; release to mask it again.
const PasswordInput = React.forwardRef(
  ({ id, value, onChange, placeholder = "Your password", className = "h-12", ...rest }, ref) => {
    const [show, setShow] = useState(false);

    const reveal = () => setShow(true);
    const conceal = () => setShow(false);

    return (
      <div className="relative">
        <Input
          id={id}
          ref={ref}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${className} pr-11`}
          {...rest}
        />
        <button
          type="button"
          aria-label={show ? "Hide password" : "Show password"}
          onMouseDown={reveal}
          onMouseUp={conceal}
          onMouseLeave={conceal}
          onTouchStart={reveal}
          onTouchEnd={conceal}
          onTouchCancel={conceal}
          onContextMenu={(e) => e.preventDefault()}
          className="absolute right-1.5 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
        >
          {show ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
